var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBellIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00006 0.149902C5.14365 0.149902 1.89074 3.02151 1.41241 6.84814L0.423492 14.7595C0.218369 16.4005 1.4979 17.8499 3.15165 17.8499H4.44763L4.47358 17.9083C5.2686 19.6971 7.04251 20.8499 9.00002 20.8499C10.9575 20.8499 12.7314 19.6971 13.5265 17.9083L13.5524 17.8499H14.8485C16.5022 17.8499 17.7817 16.4005 17.5766 14.7595L16.5877 6.84814C16.1094 3.02152 12.8565 0.149902 9.00006 0.149902ZM13.0194 16.1499C13.0068 16.1496 12.9942 16.1496 12.9816 16.1499H5.01849C5.00589 16.1496 4.99327 16.1496 4.98062 16.1499H3.15165C2.52045 16.1499 2.03207 15.5967 2.11036 14.9703L3.09928 7.059C3.47127 4.0831 6.001 1.8499 9.00006 1.8499C11.9991 1.8499 14.5288 4.0831 14.9008 7.059L15.8897 14.9703C15.968 15.5967 15.4797 16.1499 14.8485 16.1499H13.0194ZM6.39817 17.8499H11.6019C10.9959 18.6572 10.0372 19.1499 9.00002 19.1499C7.96286 19.1499 7.00417 18.6572 6.39817 17.8499Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.002f0ea7f5e7c26710119f763b7c13e0.svg";
export { ForwardRef as ReactComponent };